import * as moment from "moment";
import {JobEventApiDto, JobStatusEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {getJobStatus} from "../../../store/view/jobStatus";

/**
 * Job status changed event.
 */
export default class JobStatusEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param {JobStatusEventData} data job status change event data.
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobStatusEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobStatusEvent {
		const data = JobStatusEventData.fromJson(json.data as JobStatusEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobStatusEvent(json.id, json.jobId, JobEventTypeEnum.StatusChanged, entity,
			moment(json.createdAt), json.referenceNumber, data);
	}

	getIcon() {
		return Icon.Status;
	}

	getActivityType() {
		return "STATUS";
	}

	getActivityMessage(): string {
		const currentStatusLabel = getJobStatus(this.data.currentStatusId).map(s => s.getStatusLabel());
		return `Job Status Changed ${currentStatusLabel.map(l => "to " + l).getOrElse("")}`;
	}

}

export class JobStatusEventData {
	constructor(public readonly currentStatusId: string, public readonly previousStatusId: string) {}

	public static fromJson(json: JobStatusEventDataApiDto): JobStatusEventData {
		return new JobStatusEventData(json.current, json.previous);
	}
}
